import { render, staticRenderFns } from "./DIsputeResolutionApplications.vue?vue&type=template&id=ce507dfe&scoped=true&"
import script from "./DIsputeResolutionApplications.vue?vue&type=script&lang=js&"
export * from "./DIsputeResolutionApplications.vue?vue&type=script&lang=js&"
import style0 from "./DIsputeResolutionApplications.vue?vue&type=style&index=0&id=ce507dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce507dfe",
  null
  
)

export default component.exports